const Page = {
    OLD_DND_HOME_PAGE: 'OLD_DND_HOME_PAGE',
    HOME_PAGE: 'HOME_PAGE',
    REGISTRATION_FORM: 'REGISTRATION_FORM',
    COMPLAINT_FORM: 'COMPLAINT_FORM',
    MOBILE_REGISTRATION_SUCCESS: 'MOBILE_REGISTRATION_SUCCESS',
    FIXED_LINE_REGISTRATION_SUCCESS: 'FIXED_LINE_REGISTRATION_SUCCESS',
    COMPLAINT_SUCCESS: 'COMPLAINT_SUCCESS'
}

export default Page;